var _circle, _rect, _rect2, _rect3, _g, _path, _path2, _path3, _path4, _path5, _path6, _rect4, _rect5, _rect6, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgOpenAccessCommunityDarkMode = function SvgOpenAccessCommunityDarkMode(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 114 114",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57,
    cy: 57,
    r: 57,
    fill: "#191C1F"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 14.684,
    y: 15.257,
    width: 9.207,
    height: 2.606,
    rx: 1.303,
    transform: "rotate(45 14.684 15.257)",
    fill: "#474B51"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 11.309,
    y: 27.159,
    width: 6.69,
    height: 2.606,
    rx: 1.303,
    transform: "rotate(5.149 11.309 27.16)",
    fill: "#474B51"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 25.932,
    y: 13.029,
    width: 6.604,
    height: 2.606,
    rx: 1.303,
    transform: "rotate(77.278 25.932 13.029)",
    fill: "#474B51"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#openAccessCommunityDarkMode_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.451 27.406a2 2 0 0 1 2-2h63.097a2 2 0 0 1 2 2v21.451H23.451V27.406Z",
    fill: "#292C2F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.451 48.857h67.097v38.389a2 2 0 0 1-2 2H25.451a2 2 0 0 1-2-2V48.857Z",
    fill: "#14171A"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69.234 69.245c0 1.758-1.38 3.183-3.084 3.183-1.703 0-3.084-1.425-3.084-3.183 0-1.758 1.381-3.184 3.084-3.184s3.084 1.426 3.084 3.184Z",
    fill: "#292C2F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M66.15 73.337c-2.228 0-3.832.813-4.969 2.109-1.137 1.297-1.757 3.023-2.08 4.713h11.471c1.321 0 2.274-1.26 1.775-2.484-.346-.845-.771-1.708-1.228-2.23-1.136-1.295-2.741-2.108-4.969-2.108Z",
    fill: "#292C2F"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.171 69.245c0 1.758-1.38 3.183-3.083 3.183-1.703 0-3.084-1.425-3.084-3.183 0-1.758 1.38-3.184 3.084-3.184 1.703 0 3.083 1.426 3.083 3.184Z",
    fill: "#292C2F"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M48.088 73.337c-2.228 0-3.833.813-4.97 2.109-.61.697-1.073 1.518-1.419 2.39-.463 1.167.503 2.323 1.757 2.323h11.68s-.942-3.416-2.08-4.713c-1.136-1.296-2.74-2.109-4.968-2.109Z",
    fill: "#292C2F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.303 66.604c0 2.245-1.775 4.066-3.965 4.066s-3.965-1.82-3.965-4.066c0-2.246 1.775-4.067 3.965-4.067s3.965 1.82 3.965 4.067Z",
    fill: "#33363A"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M57.338 71.574c-2.785 0-4.79 1.023-6.211 2.654-1.422 1.632-2.197 3.804-2.6 5.93H66.15s-1.178-4.298-2.6-5.93c-1.42-1.631-3.426-2.654-6.211-2.654Z",
    fill: "#33363A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 28.011,
    height: 2.606,
    rx: 1.303,
    transform: "matrix(1 0 0 -1 28.012 38.434)",
    fill: "#33363A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 34.526,
    height: 2.606,
    rx: 1.303,
    transform: "matrix(1 0 0 -1 28.012 32.571)",
    fill: "#33363A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 15.634,
    height: 2.606,
    rx: 1.303,
    transform: "matrix(1 0 0 -1 28.012 44.297)",
    fill: "#474B51"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "openAccessCommunityDarkMode_svg__a",
    x: 13.451,
    y: 23.406,
    width: 87.098,
    height: 83.84,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 6,
    "in": "SourceAlpha",
    result: "effect1_dropShadow_1036_3484"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1036_3484"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect1_dropShadow_1036_3484",
    result: "shape"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgOpenAccessCommunityDarkMode);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "assets/openAccessCommunityDarkMode.svg";